import { Link } from "react-router-dom";
import { gossipList } from "@/mocks/gossipList";
import { formatHeat, statusClass } from "@/components/base/GossipCard";

export default function FocusTimelineSection() {
  const focus = [...gossipList].sort((a, b) => a.rank - b.rank)[0];
  if (!focus) return null;

  return (
    <section
      id="timeline"
      className="w-full bg-secondary-100 border-y border-secondary-200"
      aria-labelledby="timeline-title"
    >
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <p className="flex items-center gap-2 text-xs text-secondary-700 mb-2">
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-git-commit-line"></i>
          </span>
          EVENT THREAD
        </p>
        <h2 id="timeline-title" className="font-heading font-black text-2xl md:text-3xl text-foreground-950 mb-8">
          焦点事件脉络：一条瓜是怎么长起来的
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-10">
          <div className="lg:col-span-2">
            <div className="bg-background-50 border border-secondary-200 rounded-lg overflow-hidden">
              <div className="relative w-full h-52">
                <img
                  src={focus.cover}
                  alt={`${focus.title} - 焦点事件盘点`}
                  title={`${focus.title} - 瓜网30`}
                  className="w-full h-full object-cover object-top"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-primary-500 text-background-50 text-xs font-medium">
                  NO.{focus.rank} · {focus.category}
                </span>
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-3">
                  <span className={`text-[11px] px-2 py-0.5 rounded-full border ${statusClass(focus.status)}`}>
                    {focus.status}
                  </span>
                  <span className="text-[11px] text-foreground-500">{focus.date}</span>
                  <span className="text-[11px] text-primary-600 flex items-center gap-1">
                    <i className="ri-fire-line"></i>
                    {formatHeat(focus.heat)}
                  </span>
                </div>
                <h3 className="font-heading font-bold text-lg text-foreground-950 leading-snug">{focus.title}</h3>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{focus.summary}</p>

                <dl className="mt-5 space-y-3 border-t border-background-200 pt-5">
                  <div className="flex gap-3">
                    <dt className="w-16 shrink-0 text-xs text-foreground-500 pt-0.5">核心人物</dt>
                    <dd className="text-sm text-foreground-900">{focus.people.join(" · ")}</dd>
                  </div>
                  <div className="flex gap-3">
                    <dt className="w-16 shrink-0 text-xs text-foreground-500 pt-0.5">冲突点</dt>
                    <dd className="text-sm text-foreground-900 leading-relaxed">{focus.conflict}</dd>
                  </div>
                </dl>

                <Link
                  to={`/topic/${focus.id}`}
                  className="mt-5 inline-flex items-center gap-1.5 px-4 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
                >
                  看这条的完整脉络
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          </div>

          <div className="lg:col-span-3">
            <ol className="relative border-l-2 border-secondary-300 ml-2 space-y-8 pl-6 md:pl-8">
              {focus.timeline.map((step, index) => (
                <li key={`${step.date}-${index}`} className="relative">
                  <span className="absolute -left-[35px] md:-left-[43px] top-0.5 w-7 h-7 flex items-center justify-center rounded-full bg-accent-500 text-primary-950 font-heading font-bold text-xs">
                    {index + 1}
                  </span>
                  <p className="font-heading font-bold text-base text-primary-700 mb-1.5">{step.date}</p>
                  <p className="text-sm md:text-base text-foreground-700 leading-relaxed">{step.text}</p>
                </li>
              ))}
              <li className="relative">
                <span className="absolute -left-[35px] md:-left-[43px] top-0.5 w-7 h-7 flex items-center justify-center rounded-full bg-background-50 border-2 border-dashed border-secondary-400">
                  <i className="ri-more-line text-secondary-600"></i>
                </span>
                <p className="font-heading font-bold text-base text-foreground-500 mb-1.5">后续进展</p>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  事件仍在更新中，我们会在有新的可核实信息时补充到此条目，状态也会同步调整。
                </p>
              </li>
            </ol>

            <div className="mt-8 bg-background-50 border border-secondary-200 rounded-lg p-5">
              <h3 className="font-heading font-bold text-sm text-foreground-950 mb-2 flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-information-line text-secondary-600"></i>
                </span>
                为什么我们只给时间线，不给结论
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                同一条事件在不同平台的描述常常差别很大，原因是传播过程中信息被反复截取。
                把时间线拉出来，你能自己看到信息是怎么一步步变形的，这比接受一个现成结论更可靠。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}